export default [
    {
        component: () => import(/* webpackChunkName: 'ambulatorio-fechamento-consulta' */ '@/views/ambulatorio/fechamento-consulta/Index'),
        path: 'fechamento-consulta',
        redirect: 'fechamento-consulta/index',
        children: [
            {
                component: () => import(/* webpackChunkName: 'ambulatorio-fechamento-consulta' */'@/views/ambulatorio/fechamento-consulta/List.vue'),
                name: 'ambulatorio-fechamento-consulta-index',
                path: 'index',
            },
        ],
    },
]